import React from "react";
import { observer } from "mobx-react";
import currentCategoryStorage from "../../../storages/currentCategoryStorage";
import productsListStorage from "../../../storages/productsListStorage";

function AdditionalTextBlock({ container, text = null }) {
  console.log(
    "AT:",
    currentCategoryStorage,
    productsListStorage.currentPage,
    text
  );
  return (
    ((currentCategoryStorage.additionalText &&
      productsListStorage.currentPage == 0) ||
      text) && (
      <div
        className={container ? "container additional-text" : "additional-text"}
        dangerouslySetInnerHTML={{
          __html: text || currentCategoryStorage.additionalText,
        }}
      />
    )
  );
}

AdditionalTextBlock.propTypes = {};

export default observer(AdditionalTextBlock);
